// ============================================================
// DATA DESTINASI — edit konten di sini untuk memperbarui situs.
// Setiap destinasi punya teks Bahasa Indonesia (id) & Inggris (en).
// ============================================================

export const destinations = [
  {
    slug: 'singapore',
    image: 'https://images.unsplash.com/photo-1628221680019-f28a2716e727?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxzaW5nYXBvcmUlMjBtYXJpbmElMjBiYXl8ZW58MHx8fHwxNzkxODc1MDYxfDA&ixlib=rb-4.1.0&q=85',
    name: { id: 'Singapura', en: 'Singapore' },
    short: {
      id: 'Kota taman futuristik — ikonik, rapi, dan penuh pengalaman kelas dunia.',
      en: 'A futuristic garden city — iconic, immaculate, and full of world-class experiences.',
    },
    overview: {
      id: 'Singapura memadukan arsitektur futuristik, taman tropis, dan kuliner legendaris dalam satu pulau yang mudah dijelajahi. Cocok untuk perjalanan pertama keluarga ke luar negeri maupun liburan singkat yang mewah.',
      en: 'Singapore blends futuristic architecture, tropical gardens, and legendary cuisine on one easy-to-explore island. Perfect for a family\'s first trip abroad or a short, luxurious getaway.',
    },
    duration: { id: '3–4 hari', en: '3–4 days' },
    attractions: [
      { id: 'Marina Bay Sands & Gardens by the Bay', en: 'Marina Bay Sands & Gardens by the Bay' },
      { id: 'Sentosa Island & Universal Studios', en: 'Sentosa Island & Universal Studios' },
      { id: 'Jewel Changi Airport', en: 'Jewel Changi Airport' },
      { id: 'Chinatown, Little India & Kampong Glam', en: 'Chinatown, Little India & Kampong Glam' },
    ],
    experiences: [
      { id: 'Wisata kuliner hawker centre bersama pemandu lokal', en: 'Hawker centre food tour with a local guide' },
      { id: 'Singapore River Cruise saat matahari terbenam', en: 'Singapore River cruise at sunset' },
      { id: 'Belanja di Orchard Road & Bugis Street', en: 'Shopping on Orchard Road & Bugis Street' },
      { id: 'Night Safari — kebun binatang malam pertama di dunia', en: 'Night Safari — the world\'s first nocturnal zoo' },
    ],
    itinerary: [
      { id: 'Hari 1 — Tiba di Singapura, foto di Jewel Changi, sore di Marina Bay Sands & Spectra Light Show.', en: 'Day 1 — Arrive in Singapore, photos at Jewel Changi, evening at Marina Bay Sands & the Spectra Light Show.' },
      { id: 'Hari 2 — Seharian di Sentosa: Universal Studios, pantai, dan cable car.', en: 'Day 2 — A full day on Sentosa: Universal Studios, beaches, and the cable car.' },
      { id: 'Hari 3 — Gardens by the Bay, Chinatown, dan wisata kuliner malam di Lau Pa Sat.', en: 'Day 3 — Gardens by the Bay, Chinatown, and an evening food tour at Lau Pa Sat.' },
      { id: 'Hari 4 — Belanja oleh-oleh di Bugis, lalu pulang dengan kenangan manis.', en: 'Day 4 — Souvenir shopping at Bugis, then home with sweet memories.' },
    ],
  },
  {
    slug: 'malaysia',
    image: 'https://images.unsplash.com/photo-1597148543182-830ef7bbb904?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxtYWxheXNpYSUyMGt1YWxhJTIwbHVtcHVyfGVufDB8fHx8MTc5MTg3NTA2MXww&ixlib=rb-4.1.0&q=85',
    name: { id: 'Malaysia', en: 'Malaysia' },
    short: {
      id: 'Dari menara kembar ikonik hingga dataran tinggi sejuk dan kuliner jalanan terbaik.',
      en: 'From iconic twin towers to cool highlands and some of Asia\'s best street food.',
    },
    overview: {
      id: 'Malaysia adalah perpaduan Melayu, Tionghoa, dan India yang hidup berdampingan — menghasilkan kota yang semarak, kuliner luar biasa, dan alam tropis. Kuala Lumpur, Genting, Penang, dan Malaka mudah dikombinasikan dalam satu perjalanan privat.',
      en: 'Malaysia is a living blend of Malay, Chinese, and Indian cultures — producing vibrant cities, extraordinary food, and tropical nature. Kuala Lumpur, Genting, Penang, and Malacca combine easily into one private journey.',
    },
    duration: { id: '4–5 hari', en: '4–5 days' },
    attractions: [
      { id: 'Petronas Twin Towers & KLCC Park', en: 'Petronas Twin Towers & KLCC Park' },
      { id: 'Batu Caves', en: 'Batu Caves' },
      { id: 'Genting Highlands', en: 'Genting Highlands' },
      { id: 'Kota tua Malaka (warisan UNESCO)', en: 'Old town of Malacca (UNESCO heritage)' },
    ],
    experiences: [
      { id: 'Kuliner jalanan di Jalan Alor & Penang', en: 'Street food trails on Jalan Alor & in Penang' },
      { id: 'Cable car ke puncak Genting Highlands', en: 'Cable car ride to the top of Genting Highlands' },
      { id: 'River cruise menyusuri kota tua Malaka', en: 'River cruise through old Malacca' },
      { id: 'Belanja di Pavilion KL & Central Market', en: 'Shopping at Pavilion KL & Central Market' },
    ],
    itinerary: [
      { id: 'Hari 1 — Tiba di Kuala Lumpur, sore di KLCC Park dengan latar Petronas Towers.', en: 'Day 1 — Arrive in Kuala Lumpur, evening at KLCC Park with the Petronas Towers as backdrop.' },
      { id: 'Hari 2 — Batu Caves, Genting Highlands, dan malam kuliner di Jalan Alor.', en: 'Day 2 — Batu Caves, Genting Highlands, and an evening food crawl on Jalan Alor.' },
      { id: 'Hari 3 — Perjalanan privat ke Malaka: Dutch Square, Jonker Street, river cruise.', en: 'Day 3 — Private trip to Malacca: Dutch Square, Jonker Street, river cruise.' },
      { id: 'Hari 4 — Belanja dan santai di Bukit Bintang sebelum kembali.', en: 'Day 4 — Shopping and relaxing in Bukit Bintang before heading home.' },
    ],
  },
  {
    slug: 'thailand',
    image: 'https://images.unsplash.com/photo-1582468546235-9bf31e5bc4a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHx0aGFpbGFuZCUyMHRlbXBsZXxlbnwwfHx8fDE3OTE4NzUwNjF8MA&ixlib=rb-4.1.0&q=85',
    name: { id: 'Thailand', en: 'Thailand' },
    short: {
      id: 'Kuil emas, pantai tropis, dan keramahan legendaris Negeri Gajah Putih.',
      en: 'Golden temples, tropical beaches, and the legendary hospitality of the Land of Smiles.',
    },
    overview: {
      id: 'Thailand menawarkan segalanya: kuil megah di Bangkok, pantai Pattaya dan Phuket, pegunungan Chiang Mai, serta kuliner yang memikat. Infrastruktur wisatanya matang — sempurna untuk perjalanan privat yang nyaman.',
      en: 'Thailand offers everything: magnificent temples in Bangkok, the beaches of Pattaya and Phuket, the mountains of Chiang Mai, and captivating cuisine. Its mature tourism infrastructure makes it perfect for comfortable private travel.',
    },
    duration: { id: '4–6 hari', en: '4–6 days' },
    attractions: [
      { id: 'Grand Palace & Wat Pho, Bangkok', en: 'Grand Palace & Wat Pho, Bangkok' },
      { id: 'Pantai Pattaya & Coral Island', en: 'Pattaya Beach & Coral Island' },
      { id: 'Floating Market Damnoen Saduak', en: 'Damnoen Saduak Floating Market' },
      { id: 'Kepulauan Phi Phi (dari Phuket/Krabi)', en: 'Phi Phi Islands (from Phuket/Krabi)' },
    ],
    experiences: [
      { id: 'Dinner cruise menyusuri Sungai Chao Phraya', en: 'Dinner cruise along the Chao Phraya River' },
      { id: 'Kelas memasak masakan Thailand bersama chef lokal', en: 'Thai cooking class with a local chef' },
      { id: 'Pijat tradisional Thailand autentik', en: 'Authentic traditional Thai massage' },
      { id: 'Belanja di Chatuchak Weekend Market', en: 'Shopping at Chatuchak Weekend Market' },
    ],
    itinerary: [
      { id: 'Hari 1 — Tiba di Bangkok, sore menyusuri Sungai Chao Phraya dengan dinner cruise.', en: 'Day 1 — Arrive in Bangkok, evening dinner cruise along the Chao Phraya River.' },
      { id: 'Hari 2 — Grand Palace, Wat Pho, dan kuliner jalanan di Yaowarat (Chinatown).', en: 'Day 2 — Grand Palace, Wat Pho, and street food in Yaowarat (Chinatown).' },
      { id: 'Hari 3 — Floating market pagi hari, lalu berangkat privat ke Pattaya.', en: 'Day 3 — Morning floating market, then private transfer to Pattaya.' },
      { id: 'Hari 4 — Island hopping ke Coral Island, sunset di Pattaya Beach.', en: 'Day 4 — Island hopping to Coral Island, sunset at Pattaya Beach.' },
      { id: 'Hari 5 — Kembali ke Bangkok, belanja terakhir di ICONSIAM atau MBK.', en: 'Day 5 — Return to Bangkok, last shopping at ICONSIAM or MBK.' },
    ],
  },
  {
    slug: 'vietnam',
    image: 'https://images.unsplash.com/photo-1643029891412-92f9a81a8c16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHx2aWV0bmFtJTIwaGElMjBsb25nJTIwYmF5fGVufDB8fHx8MTc5MTg3NTA2MXww&ixlib=rb-4.1.0&q=85',
    name: { id: 'Vietnam', en: 'Vietnam' },
    short: {
      id: 'Teluk zamrud, kota tua berlampion, dan kopi terbaik di Asia Tenggara.',
      en: 'Emerald bays, lantern-lit old towns, and the best coffee in Southeast Asia.',
    },
    overview: {
      id: 'Vietnam memukau dengan Ha Long Bay yang dramatis, pesona kuno Hoi An, pantai Da Nang, dan energi Hanoi serta Ho Chi Minh City. Nilai premium yang luar biasa untuk pengalaman yang tak terlupakan.',
      en: 'Vietnam dazzles with dramatic Ha Long Bay, the ancient charm of Hoi An, the beaches of Da Nang, and the energy of Hanoi and Ho Chi Minh City. Outstanding premium value for unforgettable experiences.',
    },
    duration: { id: '5–6 hari', en: '5–6 days' },
    attractions: [
      { id: 'Ha Long Bay (situs warisan dunia UNESCO)', en: 'Ha Long Bay (UNESCO World Heritage Site)' },
      { id: 'Kota tua Hoi An & jembatan lampion', en: 'Hoi An ancient town & lantern bridge' },
      { id: 'Golden Bridge, Ba Na Hills — Da Nang', en: 'Golden Bridge, Ba Na Hills — Da Nang' },
      { id: 'Old Quarter Hanoi & Danau Hoan Kiem', en: 'Hanoi Old Quarter & Hoan Kiem Lake' },
    ],
    experiences: [
      { id: 'Cruise semalam di Ha Long Bay', en: 'Overnight cruise on Ha Long Bay' },
      { id: 'Membuat lampion tradisional di Hoi An', en: 'Traditional lantern-making in Hoi An' },
      { id: 'Tur kopi egg coffee & pho autentik di Hanoi', en: 'Egg coffee & authentic pho tour in Hanoi' },
      { id: 'Basket boat di hutan kelapa Cam Thanh', en: 'Basket boat ride in Cam Thanh coconut forest' },
    ],
    itinerary: [
      { id: 'Hari 1 — Tiba di Da Nang, santai di Pantai My Khe.', en: 'Day 1 — Arrive in Da Nang, relax on My Khe Beach.' },
      { id: 'Hari 2 — Ba Na Hills: Golden Bridge, French Village, dan cable car terpanjang.', en: 'Day 2 — Ba Na Hills: Golden Bridge, French Village, and record-breaking cable car.' },
      { id: 'Hari 3 — Hoi An seharian: kota tua, kelas lampion, dan dinner tepi sungai.', en: 'Day 3 — A full day in Hoi An: ancient town, lantern class, riverside dinner.' },
      { id: 'Hari 4 — Terbang ke Hanoi, jelajah Old Quarter dan Danau Hoan Kiem.', en: 'Day 4 — Fly to Hanoi, explore the Old Quarter and Hoan Kiem Lake.' },
      { id: 'Hari 5 — Cruise Ha Long Bay: kayak, gua, dan sunset di atas kapal.', en: 'Day 5 — Ha Long Bay cruise: kayaking, caves, and sunset on deck.' },
      { id: 'Hari 6 — Sarapan pho terakhir, lalu kembali pulang.', en: 'Day 6 — One last pho breakfast, then head home.' },
    ],
  },
  {
    slug: 'japan',
    image: 'https://images.unsplash.com/photo-1580639613257-5b1a20fe3760?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxqYXBhbiUyMGt5b3RvJTIwc3RyZWV0fGVufDB8fHx8MTc5MTg3NTA2MXww&ixlib=rb-4.1.0&q=85',
    name: { id: 'Jepang', en: 'Japan' },
    short: {
      id: 'Harmoni sempurna antara tradisi kuno dan masa depan — di setiap musim.',
      en: 'A perfect harmony of ancient tradition and the future — in every season.',
    },
    overview: {
      id: 'Jepang adalah pengalaman yang mengubah cara Anda melihat dunia: kuil Kyoto yang tenang, neon Tokyo, keanggunan Gunung Fuji, dan omotenashi — keramahan yang tulus. Indah di musim semi (sakura), gugur (momiji), maupun salju.',
      en: 'Japan changes the way you see the world: Kyoto\'s serene temples, Tokyo\'s neon, the majesty of Mount Fuji, and omotenashi — heartfelt hospitality. Beautiful in spring (sakura), autumn (momiji), and snow.',
    },
    duration: { id: '6–8 hari', en: '6–8 days' },
    attractions: [
      { id: 'Fushimi Inari & Arashiyama Bamboo Grove, Kyoto', en: 'Fushimi Inari & Arashiyama Bamboo Grove, Kyoto' },
      { id: 'Gunung Fuji & Danau Kawaguchi', en: 'Mount Fuji & Lake Kawaguchi' },
      { id: 'Shibuya, Shinjuku & Tokyo Tower', en: 'Shibuya, Shinjuku & Tokyo Tower' },
      { id: 'Kastil Osaka & Dotonbori', en: 'Osaka Castle & Dotonbori' },
    ],
    experiences: [
      { id: 'Mengenakan kimono menyusuri jalan kuno Kyoto', en: 'Wearing a kimono through Kyoto\'s old streets' },
      { id: 'Shinkansen — pengalaman kereta peluru', en: 'Shinkansen — the bullet train experience' },
      { id: 'Onsen (pemandian air panas) dengan pemandangan Fuji', en: 'Onsen (hot spring) with a view of Mount Fuji' },
      { id: 'Wisata kuliner pasar: Tsukiji Tokyo & Kuromon Osaka', en: 'Market food tours: Tokyo\'s Tsukiji & Osaka\'s Kuromon' },
    ],
    itinerary: [
      { id: 'Hari 1 — Tiba di Tokyo, malam pertama di Shinjuku & Shibuya Crossing.', en: 'Day 1 — Arrive in Tokyo, first evening in Shinjuku & Shibuya Crossing.' },
      { id: 'Hari 2 — Asakusa (Senso-ji), Tokyo Skytree, dan belanja di Ginza.', en: 'Day 2 — Asakusa (Senso-ji), Tokyo Skytree, and shopping in Ginza.' },
      { id: 'Hari 3 — Perjalanan privat ke Gunung Fuji: Danau Kawaguchi & desa Oshino Hakkai.', en: 'Day 3 — Private trip to Mount Fuji: Lake Kawaguchi & Oshino Hakkai village.' },
      { id: 'Hari 4 — Shinkansen ke Kyoto, sore di Gion — distrik geisha.', en: 'Day 4 — Shinkansen to Kyoto, evening in Gion — the geisha district.' },
      { id: 'Hari 5 — Fushimi Inari pagi hari, Arashiyama Bamboo Grove, Kinkaku-ji.', en: 'Day 5 — Fushimi Inari at dawn, Arashiyama Bamboo Grove, Kinkaku-ji.' },
      { id: 'Hari 6 — Ke Osaka: kastil, Dotonbori, dan kuliner takoyaki.', en: 'Day 6 — On to Osaka: castle, Dotonbori, and takoyaki feasting.' },
      { id: 'Hari 7 — Waktu bebas / Universal Studios Japan, lalu pulang.', en: 'Day 7 — Free time / Universal Studios Japan, then home.' },
    ],
  },
  {
    slug: 'south-korea',
    image: 'https://images.unsplash.com/photo-1602479185195-32f5cd203559?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxzb3V0aCUyMGtvcmVhJTIwc2VvdWx8ZW58MHx8fDE3OTE4NzUwNjF8MA&ixlib=rb-4.1.0&q=85',
    name: { id: 'Korea Selatan', en: 'South Korea' },
    short: {
      id: 'Istana Joseon, K-culture, dan kota yang tak pernah berhenti memukau.',
      en: 'Joseon palaces, K-culture, and a city that never stops dazzling.',
    },
    overview: {
      id: 'Korea Selatan memadukan istana berusia 600 tahun dengan budaya pop paling berpengaruh di dunia. Seoul menawarkan belanja, kuliner, K-beauty, dan sejarah dalam satu kota yang efisien dan aman.',
      en: 'South Korea pairs 600-year-old palaces with the world\'s most influential pop culture. Seoul offers shopping, cuisine, K-beauty, and history in one efficient, safe city.',
    },
    duration: { id: '5–6 hari', en: '5–6 days' },
    attractions: [
      { id: 'Istana Gyeongbokgung & Bukchon Hanok Village', en: 'Gyeongbokgung Palace & Bukchon Hanok Village' },
      { id: 'N Seoul Tower & Sungai Han', en: 'N Seoul Tower & the Han River' },
      { id: 'Myeongdong & Hongdae', en: 'Myeongdong & Hongdae' },
      { id: 'Pulau Nami & Petite France', en: 'Nami Island & Petite France' },
    ],
    experiences: [
      { id: 'Sewa hanbok dan berfoto di istana Gyeongbokgung', en: 'Rent a hanbok and take photos at Gyeongbokgung Palace' },
      { id: 'K-beauty shopping & skincare haul di Myeongdong', en: 'K-beauty shopping & skincare haul in Myeongdong' },
      { id: 'Piknik malam di tepi Sungai Han', en: 'Evening picnic by the Han River' },
      { id: 'Kelas memasak kimchi & hidangan Korea', en: 'Kimchi & Korean cooking class' },
    ],
    itinerary: [
      { id: 'Hari 1 — Tiba di Seoul, malam di Myeongdong: street food & K-beauty.', en: 'Day 1 — Arrive in Seoul, evening in Myeongdong: street food & K-beauty.' },
      { id: 'Hari 2 — Gyeongbokgung dengan hanbok, Bukchon Hanok Village, Insadong.', en: 'Day 2 — Gyeongbokgung in hanbok, Bukchon Hanok Village, Insadong.' },
      { id: 'Hari 3 — Pulau Nami & Garden of Morning Calm — perjalanan privat sehari.', en: 'Day 3 — Nami Island & Garden of Morning Calm — a private day trip.' },
      { id: 'Hari 4 — Hongdae, N Seoul Tower, dan piknik Sungai Han.', en: 'Day 4 — Hongdae, N Seoul Tower, and a Han River picnic.' },
      { id: 'Hari 5 — Belanja terakhir di Dongdaemun atau COEX, lalu pulang.', en: 'Day 5 — Last shopping at Dongdaemun or COEX, then home.' },
    ],
  },
  {
    slug: 'china',
    image: 'https://images.unsplash.com/photo-1514920735211-8c697444a248?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxjaGluYSUyMGxhbmRzY2FwZXxlbnwwfHx8MTc5MTg3NTA2MHww&ixlib=rb-4.1.0&q=85',
    name: { id: 'China', en: 'China' },
    short: {
      id: 'Peradaban 5.000 tahun — dari Tembok Besar hingga pegunungan avatar.',
      en: 'A 5,000-year civilization — from the Great Wall to avatar mountains.',
    },
    overview: {
      id: 'China adalah perjalanan melintasi waktu: Tembok Besar, Kota Terlarang, Tentara Terakota, dan lanskap karst Guilin yang seperti lukisan. Dengan transportasi privat dan pemandu berpengalaman, China menjadi sangat mudah dijelajahi.',
      en: 'China is a journey through time: the Great Wall, the Forbidden City, the Terracotta Army, and Guilin\'s painting-like karst landscapes. With private transport and experienced guides, China becomes remarkably easy to explore.',
    },
    duration: { id: '6–8 hari', en: '6–8 days' },
    attractions: [
      { id: 'Tembok Besar China (Mutianyu)', en: 'The Great Wall of China (Mutianyu)' },
      { id: 'Kota Terlarang & Lapangan Tiananmen, Beijing', en: 'Forbidden City & Tiananmen Square, Beijing' },
      { id: 'Tentara Terakota, Xi\'an', en: 'Terracotta Army, Xi\'an' },
      { id: 'The Bund & Shanghai Tower', en: 'The Bund & Shanghai Tower' },
    ],
    experiences: [
      { id: 'Menyusuri Tembok Besar di pagi hari yang sepi', en: 'Walking the Great Wall in the quiet of morning' },
      { id: 'Santapan Peking duck autentik di Beijing', en: 'Authentic Peking duck dinner in Beijing' },
      { id: 'Kereta cepat antar kota — hingga 350 km/jam', en: 'High-speed rail between cities — up to 350 km/h' },
      { id: 'Huangpu River cruise dengan skyline Shanghai', en: 'Huangpu River cruise with the Shanghai skyline' },
    ],
    itinerary: [
      { id: 'Hari 1 — Tiba di Beijing, malam di Wangfujing.', en: 'Day 1 — Arrive in Beijing, evening on Wangfujing Street.' },
      { id: 'Hari 2 — Kota Terlarang, Lapangan Tiananmen, dan Temple of Heaven.', en: 'Day 2 — Forbidden City, Tiananmen Square, and the Temple of Heaven.' },
      { id: 'Hari 3 — Tembok Besar Mutianyu dengan cable car, malam Peking duck.', en: 'Day 3 — Mutianyu Great Wall by cable car, Peking duck dinner.' },
      { id: 'Hari 4 — Kereta cepat ke Xi\'an, sore di Muslim Quarter.', en: 'Day 4 — High-speed train to Xi\'an, evening in the Muslim Quarter.' },
      { id: 'Hari 5 — Tentara Terakota dan tembok kota kuno Xi\'an.', en: 'Day 5 — Terracotta Army and Xi\'an\'s ancient city wall.' },
      { id: 'Hari 6 — Terbang ke Shanghai: Yu Garden, Nanjing Road, The Bund.', en: 'Day 6 — Fly to Shanghai: Yu Garden, Nanjing Road, The Bund.' },
      { id: 'Hari 7 — Shanghai Tower dan river cruise sebelum kembali pulang.', en: 'Day 7 — Shanghai Tower and a river cruise before heading home.' },
    ],
  },
  {
    slug: 'maldives',
    image: 'https://images.unsplash.com/photo-1602002418816-5c0aeef426aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxtYWxkaXZlcyUyMHJlc29ydHxlbnwwfHx8fDE3OTE4NzUwNjF8MA&ixlib=rb-4.1.0&q=85',
    name: { id: 'Maladewa', en: 'Maldives' },
    short: {
      id: 'Surga samudra — vila di atas air, pasir seputih tepung, laut sebening kaca.',
      en: 'Ocean paradise — overwater villas, flour-white sand, glass-clear seas.',
    },
    overview: {
      id: 'Maladewa adalah definisi pelarian sempurna: resor pulau pribadi, vila di atas air, dan laguna biru kehijauan. Ideal untuk bulan madu, anniversary, atau sekadar berhenti sejenak dari dunia.',
      en: 'The Maldives is the definition of a perfect escape: private island resorts, overwater villas, and turquoise lagoons. Ideal for honeymoons, anniversaries, or simply pressing pause on the world.',
    },
    duration: { id: '4–5 hari', en: '4–5 days' },
    attractions: [
      { id: 'Resor pulau privat & water villa', en: 'Private island resorts & water villas' },
      { id: 'Snorkeling di house reef bersama penyu', en: 'Snorkeling the house reef with turtles' },
      { id: 'Sandbank picnic di tengah samudra', en: 'Sandbank picnic in the middle of the ocean' },
      { id: 'Sunset dolphin cruise', en: 'Sunset dolphin cruise' },
    ],
    experiences: [
      { id: 'Menginap di vila di atas air dengan akses langsung ke laguna', en: 'Staying in an overwater villa with direct lagoon access' },
      { id: 'Romantic dinner di tepi pantai privat', en: 'Romantic dinner on a private beach' },
      { id: 'Spa dengan pemandangan samudra', en: 'Spa treatments overlooking the ocean' },
      { id: 'Diving atau snorkeling bersama pari manta', en: 'Diving or snorkeling with manta rays' },
    ],
    itinerary: [
      { id: 'Hari 1 — Tiba di Malé, speedboat/seaplane ke resor, sunset pertama di vila.', en: 'Day 1 — Arrive in Malé, speedboat/seaplane to the resort, first sunset at your villa.' },
      { id: 'Hari 2 — Snorkeling house reef, sore bersantai di pantai privat.', en: 'Day 2 — House reef snorkeling, afternoon on your private beach.' },
      { id: 'Hari 3 — Sandbank picnic dan sunset dolphin cruise.', en: 'Day 3 — Sandbank picnic and sunset dolphin cruise.' },
      { id: 'Hari 4 — Spa pagi hari, romantic dinner di tepi laut.', en: 'Day 4 — Morning spa, romantic seaside dinner.' },
      { id: 'Hari 5 — Sarapan terakhir di atas laguna, lalu kembali dengan hati penuh.', en: 'Day 5 — One last breakfast over the lagoon, then home with a full heart.' },
    ],
  },
];
